import ISmartExchangeClaims from '@/models/se/ISmartExchangeClaims';
import BaseApiService from '../BaseApiService';
import WebEnvConfig from '@/models/WebEnvConfig';
import SmartExchangeRequest from '@/models/requests/SmartExchangeRequest';
import IFeedData from '@/models/comp/IFeedData';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import SmartExchangeSubsRequest from '@/models/requests/SmartExchangeSubsRequest';
import IServiceHelper from '../IServiceHelper';
import ServiceHelperFactory from './ServiceHelperFactory';

export default class SmartExchangeService extends BaseApiService {
    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async getBestComp(request: SmartExchangeRequest): Promise<IFeedData | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/SmartExchangeBestComp', request);
            if (response.data) {
                if (response.status === 200) {
                    const result: IFeedData = response.data;
                    return result;
                }
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            const addressDescription = CompAddressUtils.getDescription(request.address);
            console.log(`SmartExchangeService.getBestComp(), Error[${errorDescription}] on address[${addressDescription}], isSubject[${request.isSubject}], formCode[${request.formCode}]`);
        }

        return null;
    }

    async getSubComps(request: SmartExchangeSubsRequest): Promise<IFeedData[] | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const data = JSON.stringify(request);

            const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/SmartExchangeComps', data);
            if (response.status === 200) {
                const result: IFeedData[] = response.data;
                return result;
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            const addressDescription = CompAddressUtils.getDescription(request.address);
            console.log(`SmartExchangeService.getSubComps(), Error[${errorDescription}] on address[${addressDescription}], formCode[${request.formCode}]`);
        }

        return null;
    }

    async getClaims(userLoginToken: string): Promise<ISmartExchangeClaims | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const data = JSON.stringify(userLoginToken);
            const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/SmartExchangeClaims', data);
            const result: ISmartExchangeClaims = {
                userAccessToken: response.data.userAccessToken,
                isOptedIn: response.data.isOptedIn,
                optInUrl: response.data.optInUrl,
                statusCode: response.status,
            };

            return result;
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            console.log(`SmartExchangeService.getClaims(), Error[${errorDescription}]`);
        }

        return null;
    }
}
